export default __webpack_public_path__ + "static/media/mq.9cdae873.svg";